import { resolverUbicacion } from './useCiudadesTraslado';

export function validarRecorrido(contexto, trayecto, valores, departamentos, ciudades, invertir = false) {
  if (!contexto?.configurada) return ['Espere la configuración vigente de la autorización.'];
  if (!['Ida', 'Retorno'].includes(trayecto)) return ['El traslado no tiene un trayecto Ida o Retorno válido.'];
  const errores = [];
  for (const lado of ['origen', 'destino']) {
    const fuente = invertir ? (lado === 'origen' ? 'destino' : 'origen') : lado;
    const key = trayecto === 'Retorno' ? (lado === 'origen' ? 'destino' : 'origen') : lado;
    const regla = contexto.ambitos?.[key];
    const dep = resolverUbicacion(departamentos, valores?.[fuente + '_departamento']);
    const city = dep && resolverUbicacion(ciudades.filter(c => Number(c.departamento_id) === Number(dep.id)), valores?.[fuente + '_ciudad']);
    if (!dep || !regla?.departamentos.map(Number).includes(Number(dep.id))) {
      errores.push('El departamento de ' + lado + ' no está permitido o debe seleccionarse nuevamente.');
    } else if (!city || (regla.modo !== 'todas' && !regla.ciudades.map(Number).includes(Number(city.id)))) {
      errores.push('La ciudad de ' + lado + ' no está permitida o debe seleccionarse nuevamente.');
    }
  }
  return errores;
}
